import {Box, SvgIcon} from "@mui/material";
import React from "react";

export function ClothesIcon(props) {
  return(
      <img src="/Icons/clothes.svg" alt="clothes" {...props}/>
  )
}